import { createTheme } from "@mui/material";



export const Mytypo=createTheme({
    typography:{
        fontFamily:'Poppins',
    }
})